import DataSource, { DataSourceService, DataSourceServiceMapDelegate, DataSourceData } from "./datasource";

export type FetchInitMapDelegate = (dataSource: DataSource, argument?: any) => RequestInit 
export type FetchResponseParser = (response: Response) => DataSourceData
export default class FetchDataSourceService implements DataSourceService {

    private fetchInitMap: FetchInitMapDelegate | undefined;
    private queryStringMap: DataSourceServiceMapDelegate | undefined;
    private responseParser: FetchResponseParser | undefined;
    private abortControler: AbortController | undefined;

    constructor(public readonly name: string, public readonly url: string, public readonly method: string = "GET") { }

    fetch(dataSource: DataSource, argument?: any): Promise<DataSourceData> {

        if (this.abortControler)
            this.abortControler.abort();

        this.abortControler = new AbortController();

        return new Promise<DataSourceData>((resolve, reject) => {

            const requestInit: RequestInit = this.fetchInitMap ? this.fetchInitMap(dataSource, argument) : {};
            const invokeUrl: RequestInfo = this.buildUrl(dataSource, argument);

            if (!requestInit.signal) {
                requestInit.signal = this.abortControler?.signal;
            }

            return fetch(invokeUrl, requestInit)
                .then(response => {

                    if (!response.ok) {
                        reject(response.text());
                        return;
                    }

                    let responseData: DataSourceData;

                    if (this.responseParser) {
                        responseData = this.responseParser(response);
                    }
                    else {
                        responseData = response.json;
                    }
                    resolve(responseData);
                });
        });
    }

    setQueryStringMap(handler: DataSourceServiceMapDelegate): FetchDataSourceService {
        this.queryStringMap = handler;
        return this;
    }

    setFetchInitMap(handler: FetchInitMapDelegate): FetchDataSourceService {
        this.fetchInitMap = handler;
        return this;
    }

    setResponseParser(handler: FetchResponseParser): FetchDataSourceService {
        this.responseParser = handler;
        return this;
    }

    toString(): string {
        return `${this.method.toUpperCase()} ${this.url}`
    }

    private buildUrl(dataSource: DataSource, argument: any): string {

        let parameters: Record<string, string> = {};

        const currentFilterText: string = dataSource?.filters[0]?.toString() || '';

        // Get Parameters
        if (this.queryStringMap) {
            parameters = this.queryStringMap({
                argument: argument,
                filterText: currentFilterText
            });
        }

        // Build QueryString
        let queryString = "";
        Object.entries(parameters).forEach(([key, value]) => {
            queryString += `${queryString !== "" ? "&" : ""}${key}=${(value === null || value === undefined) ? "" : encodeURIComponent(value.toString())}`;
        });

        // Build Url
        const invokeUrl = this.url +
            (queryString ? (this.url.indexOf("?") === -1 ? "?" : "&") + queryString : "");

        return invokeUrl;
    }
}
